import { ACTION } from './interfaces';
import type {
  AddUpdatedTimestampAction,
  FreemiumAction,
  UpdateCanAccessTofPremiumAction,
  UpdateDataAction,
  UpdatePremiumAnalyticsFilterModalStatusAction,
  UpdatePremiumFiltersAction,
  UpdatePremiumOverviewLoadingStatusAction,
} from './interfaces';

const actions = {
  addUpdatedTimestamp({
    reducerDispatch,
    updatedTimestamp,
  }: {
    reducerDispatch: React.Dispatch<FreemiumAction>;
    updatedTimestamp: AddUpdatedTimestampAction['payload']['updatedTimestamp'];
  }) {
    reducerDispatch({
      type: ACTION.ADD_UPDATED_TIMESTAMP,
      payload: {
        updatedTimestamp,
      },
    });
  },

  updatePremiumFilters({
    reducerDispatch,
    filters,
  }: {
    reducerDispatch: React.Dispatch<FreemiumAction>;
    filters: UpdatePremiumFiltersAction['payload']['filters'];
  }) {
    reducerDispatch({
      type: ACTION.UPDATE_FILTERS,
      payload: {
        filters,
      },
    });
  },
  updatePremiumOverviewLoadingStatus({
    reducerDispatch,
    isPremiumOverviewLoading,
  }: {
    reducerDispatch: React.Dispatch<FreemiumAction>;
    isPremiumOverviewLoading: UpdatePremiumOverviewLoadingStatusAction['payload']['isPremiumOverviewLoading'];
  }) {
    reducerDispatch({
      type: ACTION.UPDATE_PREMIUM_OVERVIEW_LOADING_STATUS,
      payload: {
        isPremiumOverviewLoading,
      },
    });
  },
  updateData({
    reducerDispatch,
    data,
  }: {
    reducerDispatch: React.Dispatch<FreemiumAction>;
    data: UpdateDataAction['payload']['data'];
  }) {
    reducerDispatch({
      type: ACTION.UPDATE_DATA,
      payload: {
        data,
      },
    });
  },
  updatePremiumAnalyticsFilterModalStatus({
    reducerDispatch,
    isPremiumAnalyticsFilterModalOpen,
  }: {
    reducerDispatch: React.Dispatch<FreemiumAction>;
    isPremiumAnalyticsFilterModalOpen: UpdatePremiumAnalyticsFilterModalStatusAction['payload']['isPremiumAnalyticsFilterModalOpen'];
  }) {
    reducerDispatch({
      type: ACTION.UPDATE_PREMIUM_ANALYTICS_FILTER_MODAL_STATUS,
      payload: {
        isPremiumAnalyticsFilterModalOpen,
      },
    });
  },
  updateCanAccessTopOfFunnelPremium({
    reducerDispatch,
    canAccessTopOfFunnelPremium,
  }: {
    reducerDispatch: React.Dispatch<FreemiumAction>;
    canAccessTopOfFunnelPremium: UpdateCanAccessTofPremiumAction['payload']['canAccessTopOfFunnelPremium'];
  }) {
    reducerDispatch({
      type: ACTION.UPDATE_CAN_ACCESS_TOF_PREMIUM,
      payload: {
        canAccessTopOfFunnelPremium,
      },
    });
  },
};

export default actions;
